import { api_v2 } from "./api"

interface DashboardParams {
  data_inicio?: string
  data_fim?: string
}

export const getDashboard = async (params?: DashboardParams): Promise<void> => {
  return await api_v2.get("/mentoria/dashboard", { params })
}
